<template>
    <div>
      <div class='fourlist'>
        <div style="borderRight:1px solid #d8d8d8;font-size: 18px">{{$lang.xggp}}</div>
        <div v-for='(v,i) in list' :key='i+"101"' :style="{borderRight:(i+1)<list.length?'1px solid #d8d8d8':''}" @click='handclick(i)'>
        <span :style="{borderBottom:isright==i?'3px solid #09666E':''}">{{v}}</span>
        </div>
      </div>
    </div>
</template>

<script>
  export default{
    props:['isnum'],
    data(){
      return{
        islang : window.localStorage.guanwanglang,
        list:[this.$lang.scjs,this.$lang.jyfs,this.$lang.fwsf],
        urllist:['/hksecurities_introduction','/hksecurities_information','/hksecurities_fees'],
        isright:0
      }
    },
    watch:{
      isnum:{
        immediate:true,
        handler(ev){
          this.isright = this.isnum
        }
      }
    },
    methods:{
      handclick(i){
          this.isright = i
         
        if(this.urllist[i]){
          this.$router.push(this.urllist[i])
        }
      }
    }
  }
</script>

<style scoped>
  .fourlist{
    /* display: flex;
    justify-content: space-between; */
    font-size: 16px;
    margin-bottom: 2.5rem;
    margin-left: -1rem;
  }
  .fourlist div{
    display: inline-block;
    padding: 0 1rem;
    font-size: 16px ;   color: #000;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/compoents/fourlist.vue